
<h1 (click)="isOpen = !isOpen"><mat-icon [ngClass]="{ open: isOpen }">expand_more</mat-icon>{{title}}</h1>

<div class="card" *ngIf="isOpen">

  <p-table #dt1 [value]="uploadedItems" *ngIf="uploadedItems?.length > 0" dataKey="id" [rows]="10" [rowHover]="true" styleClass="p-datatable-gridlines"
           [paginator]="true" [globalFilterFields]="['catalogNumber','quantity','productCode','modelName']">
    <ng-template pTemplate="caption">
      <div class="flex justify-content-between flex-column sm:flex-row">

        <button pButton label="Clear" class="p-button-outlined mb-2" icon="pi pi-filter-slash" (click)="clear(dt1)"></button>
        <button pButton label="Export" class="p-button-outlined mb-2" icon="pi pi-cloud-download" (click)="Download(dt1)"></button>

        <span class="p-input-icon-left mb-2">
          <i class="pi pi-search"></i>
          <input pInputText type="text" #filter (input)="onGlobalFilter(dt1, $event)" placeholder="Search Keyword" class="w-full" />
        </span>
      </div>
    </ng-template>
    <ng-template pTemplate="header">
      <tr>
        <th style="min-width: 12rem">
          <div class="flex justify-content-between align-items-center">
            Catalog Number
            <p-columnFilter type="text" field="catalogNumber" display="menu" placeholder="Search by Catalog Number"></p-columnFilter>
          </div>
        </th>
        <th style="min-width: 12rem">
          <div class="flex justify-content-between align-items-center">
            Quantity
            <p-columnFilter type="text" field="quantity" display="menu" placeholder="Search by Quantity"></p-columnFilter>
          </div>
        </th>
        <th style="min-width: 14rem">
          <div class="flex justify-content-between align-items-center">
            ProductCode
            <p-columnFilter type="text" field="productCode" display="menu" placeholder="Search by ProductCode"></p-columnFilter>
          </div>
        </th>
        <th style="min-width: 10rem">
          <div class="flex justify-content-between align-items-center">
            Product Name
            <p-columnFilter type="text" field="modelName" display="menu"></p-columnFilter>
          </div>
        </th>
        <th style="min-width: 10rem">
          <div class="flex justify-content-between align-items-center">
            Image
    
          </div>
        </th>
        <th style="min-width: 10rem">
          <div class="flex justify-content-between align-items-center">
           Loaded On

          </div>
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-item>
      <tr>
        <td>
          {{ item.catalogNumber }}
        </td>
        <td>
          <span class="image-text ml-2">{{ item.quantity }}</span>
        </td>
        <td>
          {{item.productCode}}
          <span class="image-text ml-2"> </span>
        </td>
        <td>
          {{item.modelName}}
        </td>
        <td>
          <img [src]="item.image" width="60" height="60" style="object-fit: contain;" alt="Product Image">
        </td>
        <td>
          {{ item.loadedOn | date:'short' }}
        </td>
        
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="8">No customers found.</td>
      </tr>
    </ng-template>
    <ng-template pTemplate="loadingbody">
      <tr>
        <td colspan="8">Loading gating data. Please wait.</td>
      </tr>
    </ng-template>
  </p-table>
</div>
